export const paymentTypes = {
  INCOME: 'INCOME',
  OUTCOME: 'OUTCOME',
}
